import { Box, Typography } from "@mui/material";
import { CMChip } from "../../common/CMChip";
import { flattenRelationshipsForDisplay } from "../../../utilities/relationshipUtils";
import { getCategoryColor } from "../../../utilities/dataItemUtils";
import { isColorDark } from "../../../utilities/common";

import type { BaseDataItem, Config } from "../../../types";

type RelationshipChipsProps = {
  relationships?: BaseDataItem['relationships']
  config: Config;
};

export default function RelationshipChips({ relationships = { byTableSlug: {}, media: [] }, config }: RelationshipChipsProps) {
  console.log("[EntityForm] renderRelationships called");
  console.log("[EntityForm] currentItem?.relationships:", relationships);

  if (!relationships) {
    console.log("[EntityForm] No relationships found - returning placeholder");
    return (
      <Typography variant='body2' color='text.secondary' sx={{ fontStyle: "italic" }}>
        No relationships defined
      </Typography>
    );
  }

  // Media items have their own dedicated section — exclude them from relationship chips
  const allRelationshipItems = flattenRelationshipsForDisplay(relationships, config).filter(
    (item) => item.category !== "media"
  );

  console.log("[EntityForm] Total relationship items found:", allRelationshipItems.length);

  // If no relationships found after processing, show placeholder
  if (allRelationshipItems.length === 0) {
    console.log("[EntityForm] No relationship items found after processing - returning placeholder");
    return (
      <Typography variant='body1' color='grey.400'>
        No relationships found
      </Typography>
    );
  }

  // Render all relationships as chips in a single container
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        gap: 0.5,
        justifyContent: "flex-start"
      }}
    >
      {allRelationshipItems.map((item) => {
        const bgColor = getCategoryColor(item.category);
        const textColor = isColorDark(bgColor) ? "#ffffff" : "#000000";

        return (
          <CMChip
            key={`${item.key}-${item.id}`}
            label={item.name}
            size='small'
            aria-label={item?.name}
            sx={{
              height: "2.125rem",
              fontSize: "0.65rem",
              bgcolor: bgColor,
              color: textColor,
              padding: "0.5rem 0.75rem",
              borderRadius: "0.5rem",
              boxShadow: 'none',
              "& .MuiChip-label": {
                fontSize: "0.875rem",
                px: 0.75,
                py: 0
              }
            }}
          />
        );
      })}
    </Box>
  );
}
